import { AlertMessage } from '../constant';

export function i10nAlert(code = 'unknown') {
  const lang = sessionStorage.getItem('lang');
  try {
    alert(AlertMessage[code][lang]);
  } catch {
    alert(AlertMessage['unknown'][lang]);
  }
}

export function errorAlert(error) {
  const axiosError = error.response.data;
  if (axiosError) {
    const errorCode = axiosError?.resultCode?.code;
    errorCode ? i10nAlert(errorCode) : i10nAlert();
    if (/(401002)|(401902)/g.test(errorCode)) {
      localStorage.removeItem('userData');
      window.location.reload();
    }
  }
}
